<template>
  <v-flex>
    <v-layout
      column
      fill-height
      justify-center
      style="align-items: stretch;"
    >
      <v-flex>
        <box-search
          box-width="400"
          title="Tutti utenti"
          :items="utentiUniq"
          item-key="login"
          item-label="nominativo"
        >
          <template v-slot:items="{item}">
            <v-list-tile-content>
              <v-list-tile-title v-html="item.nominativo" />
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn
                small
                outline
                depressed
                color="tree"
                @click.prevent="resetPasswordHandler(item)"
              >Reset pass</v-btn>
            </v-list-tile-action>
          </template>
        </box-search>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BoxSearch from './BoxSearch.vue'

export default {
  name: "CTabPermessi",
  components: {
    BoxSearch
  },
  props: {
  },
  data () {
    return {
    };
  },
  computed: {
    ...mapState('settings', ['utenti']),
    utentiUniq () {
      return Array.from(new Set(this.utenti.map(c => c.login)))
        .map((c, i) => this.utenti.find(u => u.login === c))
    }
  },
  async created () {
    await this.getAllUtenti()
  },
  methods: {
    ...mapActions('settings', ['getAllUtenti', 'resetPassword']),
    resetPasswordHandler (item) {
      this.$swal({
        type: 'warning',
        html: 'Sei sicuro di volere resettare password a <br/>' + item.nominativo + ' ?',
        showCancelButton: true,
        confirmButtonText: 'Reset',
        cancelButtonText: 'Annulla',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return this.resetPassword({login: item.login})
            .catch(error => {
              this.$swal.showValidationMessage(
                `Request failed: ${error}`
              )
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then((result) => {
        if (result.value && result.value.stato === 'success') {
          this.$swal.fire({
            type: 'success',
            html: `IL nuovo password per <span class="font-weight-bold">${item.nominativo}</span> è: <p class=" mt-2 display-2 font-weight-bold font-italic">${result.value.data.password_temp}</p>`
          })
        } else {
          this.$swal.fire({
            type: 'error',
            html: `<p class=" mt-2 title">Operazione fallita con messaggio <br/><p class="mt-2 red--text text--darken-4 font-weight-bold font-italic">"${result.value.textError}"</p>.</p>`
          })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.v-tabs {
  /deep/ .v-tabs__container {
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/Settings/TabResetPassword.vue